import { SystemConversionEventDefinition } from 'modules/experiments/types/tableQuery';
import { OriginalExperimentState } from 'modules/experiments/takeover/types';

export type EditExperimentZodFormValuesType = {
  holdOutGroupSize?: number;
  attributionPeriodHours?: number;
  testSizePercentage?: number;
  hasHoldOutGroup?: boolean;
  winningCriteriaName?: string;
  testDurationHours?: number;
  testDurationMinutes?: number;
  sendTimeStartTimeZone?: string;
  sendTimeUseRecipientTimeZones?: boolean;
  testSendsPerVariation?: number;
  triggeredTestStrategy?: TestStrategy;
  testStrategy?: TestStrategy;
};

export enum SystemConversionsEventType {
  Clicks = 'Clicks',
  Opens = 'Opens',
}

export type WinningCriteriaInput = {
  systemConversionEvents: SystemConversionsEventType | '';
  conversionEventIds: number[];
};

type ConversionEventSettingsInput = {
  systemConversionEventType?: SystemConversionEventDefinition | null;
  customConversionId?: number | null;
};

type SendTimeSettingsInput = {
  sendTimeUseRecipientTimeZones?: boolean;
  sendTimeStartTimeZone?: string;
};

type TriggerExplorationSettingsInput = {
  testSendsPerVariation?: number;
};

type BlastExplorationSettingsInput = {
  testSizePercentage?: number;
  testDurationMinutes?: number;
};

type HoldoutSettingsInput = {
  holdOutGroupSize?: number;
  attributionPeriodHours?: number;
};

export type UpdateExperimentsArgs = {
  experimentId: number;
  conversionEventSettings: ConversionEventSettingsInput;
  sendTimeSettings?: SendTimeSettingsInput | null;
  explorationTriggerSettings?: TriggerExplorationSettingsInput | null;
  explorationBlastSettings?: BlastExplorationSettingsInput | null;
  holdoutSettings?: HoldoutSettingsInput | null;
};

export type SaveExperimentSettingsResponse =
  | {
      isSuccess: true;
      data: OriginalExperimentState;
    }
  | {
      isSuccess: false;
    };

export enum TestStrategy {
  ALL_USERS = 'all users',
  SUBSET_USERS = 'subset users',
}
